import { render, staticRenderFns } from "./SmbIconButton.vue?vue&type=template&id=1b4976e4&scoped=true&"
import script from "./SmbIconButton.vue?vue&type=script&lang=ts&"
export * from "./SmbIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./SmbIconButton.scss?vue&type=style&index=0&id=1b4976e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4976e4",
  null
  
)

export default component.exports